// extracted by mini-css-extract-plugin
module.exports = {"formInput":"Input_formInput__1ffOc"};